/**
 * 商店管理
 */
import { SHOPMANAGE } from '../types';

export default {
    name: `${SHOPMANAGE}`,
    path: '/shopManage',
    component: () => import(/* webpackChunkName: 'shopManage' */ '@/views/shopManage/'),
    redirect: { name: `${SHOPMANAGE}Index` },
    meta: {
        title: '商店管理',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${SHOPMANAGE}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'shopManage' */ '@/views/shopManage/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${SHOPMANAGE}Devise`,
            path: 'devise/:id',
            component: () => import(/* webpackChunkName: 'shopManage' */ '@/views/shopManage/devise/Devise.vue'),
        },
    ],
};
